import { reviews } from "@/mocks/reviews";

export default function Reviews() {
  return (
    <section id="reviews" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-block rounded-full bg-accent-100 px-4 py-1 text-sm font-medium text-accent-900">
          用户口碑
        </span>
        <h2 className="mt-4 text-2xl font-black text-foreground-950 md:text-4xl">
          帮助中心好不好用，读者说了算
        </h2>
        <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
          来自真实读者的反馈，我们的步骤是否简单、管用，看他们怎么说。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {reviews.map((r) => (
          <figure
            key={r.id}
            className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-6"
          >
            <div className="flex items-center gap-1 text-sm text-secondary-500">
              {Array.from({ length: 5 }).map((_, si) => (
                <i key={si} className="ri-star-fill" />
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-6 text-foreground-700">
              “{r.content}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-background-50 ${r.avatarHue}`}
              >
                {r.name.slice(0, 1)}
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                <p className="text-xs text-foreground-600">{r.role}</p>
              </div>
            </figcaption>
            <div className="mt-4 flex flex-wrap gap-1.5">
              {r.tags.map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-background-100 px-2.5 py-0.5 text-xs text-foreground-600"
                >
                  {t}
                </span>
              ))}
            </div>
          </figure>
        ))}
      </div>
    </section>
  );
}